import { useCepAutocomplete } from 'components/addressField/fields/utils/addressChanges'
import PropTypes, {
	array,
	bool,
	func,
	number,
	object,
	string,
} from 'prop-types'
import React, { useState, useEffect } from 'react'
import { getAllClasses, getAllComponents } from './utils/dictsImport'

const NaturalPerson = ({
	fields,
	name,
	form,
	inputValue,
	onChange,
	onFocus,
	optional,
	disabled,
	visible,
	first,
	getLoading,
	personList,
	variableListName,
	listLabelChange,
}) => {
	const components = getAllComponents()
	const classNames = getAllClasses()

	let fieldMarital = ''
	if (typeof fields !== 'string') {
		const field = fields.find((f) => f === 'marital_state')
		if (field !== undefined) fieldMarital = inputValue[field]
	}

	let fieldState = ''
	if (typeof fields !== 'string') {
		const field = fields.find((f) => f === 'state')
		if (field !== undefined) fieldState = inputValue[field]
	}

	const [pronoun, setPronoun] = useState('')
	const [maritalState, setMaritalState] = useState(fieldMarital)
	const [state, setState] = useState(fieldState)

	const [setCep, loadingCep] = useCepAutocomplete(
		form,
		fields,
		name,
		setState,
		onChange,
		personList,
		variableListName
	)

	useEffect(() => {
		getLoading(loadingCep ? true : false, name)
	}, [getLoading, loadingCep, name])

	return (
		<div style={{ display: 'flex', flexWrap: 'wrap', width: '100%' }}>
			{fields.map((fieldItem, i) => {
				const fieldType =
					typeof fieldItem === 'string' ? fieldItem : fieldItem.field
				if (!components[fieldType]) return null

				const dict = {
					key: `${fieldType}_${name || 'field'}`,
					name,
					inputValue: inputValue[fieldType] ?? '',
					onChange,
					onFocus,
					disabled,
					visible,
					optional,
					form,
					variableListName,
					fieldType: fieldType,
					className: classNames[fieldType],
				}

				if (i === 0 && first) {
					dict.first = first
				}

				let changeCallback = (v) => onChange(v, fieldType.toUpperCase())

				if (fieldType === 'name') {
					dict.onChange = (v) => {
						listLabelChange(v, name)
						changeCallback(v)
					}
				} else if (fieldType === 'state') {
					dict.onChange = (v) => {
						setState(v)
						changeCallback(v)
					}
				} else if (fieldType === 'pronoun') {
					dict.onChange = (v) => {
						setPronoun(v)
						changeCallback(v)
					}
				} else if (fieldType === 'marital_state') {
					dict.pronoun = pronoun
					dict.onChange = (v) => {
						setMaritalState(v)
						changeCallback(v)
					}
				} else if (fieldType === 'cep') {
					dict.onChange = (v) => {
						setCep(v)
						changeCallback(v)
					}
				} else {
					dict.onChange = changeCallback
				}

				if (fieldType === 'city') dict.state = state
				if (fieldType === 'property_regime') dict.maritalState = maritalState

				return (
					<div
						key={dict.key}
						style={{
							order: fieldType.includes('email') ? -1 : i,
							flex: fieldType.includes('email') ? '1 0 100%' : '1',
							minWidth: fieldType.includes('email') ? '100%' : '200px',
							padding: '8px',
						}}>
						{components[fieldType](dict)}
					</div>
				)
			})}
		</div>
	)
}

NaturalPerson.propTypes = {
	fields: array,
	name: PropTypes.oneOfType([number, string]),
	disabled: bool,
	visible: bool,
	onChange: func,
	onFocus: func,
	inputValue: PropTypes.oneOfType([array, object]),
}

NaturalPerson.defaultProps = {
	visible: true,
}

export default NaturalPerson
